// 主题管理：通过在 <html> 上切换 .dark 类实现明暗主题
const THEME_KEY = 'app-theme'

export function getTheme() {
  try {
    return localStorage.getItem(THEME_KEY) || 'light'
  } catch (e) {
    return 'light'
  }
}

export function setTheme(theme) {
  document.documentElement.classList.toggle('dark', theme === 'dark')
  try {
    localStorage.setItem(THEME_KEY, theme)
  } catch (e) { /* ignore */ }
}

export function toggleTheme() {
  const next = getTheme() === 'dark' ? 'light' : 'dark'
  setTheme(next)
  return next
}
